import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SFooterNav, NavItem } from '@/components/ui/organisms/SFooterNav';
import chatImage from '../../../assets/chat.png';
import './Chat.css';

const Chat = () => {
  const navigate = useNavigate();
  const [activeNav, setActiveNav] = useState<NavItem>('home');

  const handleNavClick = (item: NavItem) => {
    setActiveNav(item);
    
    // Navigate based on the selected nav item
    switch (item) {
      case 'home':
        navigate('/home');
        break;
      case 'my-game':
        navigate('/my-game');
        break;
      case 'shop':
        navigate('/shop');
        break;
      case 'profile':
        navigate('/profile');
        break;
      case 'add':
        navigate('/booking-type/location');
        break;
      default:
        break;
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-content">
        <div className="chat-state">
          <img 
            src={chatImage} 
            alt="Chat" 
            className="chat-image"
          />
          <div className="chat-text-content">
            <div className="chat-title">Coming Soon...</div>
            <div className="chat-description">
              Connect directly with your coach, review your performance, and receive personalized guidance, all in one place.
            </div>
          </div>
        </div>
      </div>

      <div className="chat-footer">
        <SFooterNav activeItem={activeNav} onItemClick={handleNavClick} />
      </div>
    </div>
  );
};

export default Chat;
